import mermaid from "mermaid";
import { useEffect, useRef, useState } from "react";

mermaid.initialize({ startOnLoad: false, securityLevel: "strict" });

let renderCount = 0;

function MermaidDiagram({ source }) {
    const containerRef = useRef(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const id = `mermaid-${renderCount++}`;

        mermaid.render(id, source)
            .then(({ svg }) => {
                if (!cancelled && containerRef.current) {
                    containerRef.current.innerHTML = svg;
                }
            })
            .catch((err) => {
                if (!cancelled) setError(err.message);
            });

        return () => { cancelled = true; };
    }, [source]);

    if (error) {
        return <pre>{source}</pre>;
    }

    return <div ref={containerRef} />;
}

export default MermaidDiagram;
